export default __webpack_public_path__ + "c159f89fa5c7723fd5197951d8521a96.svg";